/**
 *  Limpiar objeto de valores Falsy
 */
export const cleanObj = <T extends Record<string, unknown>>(obj: T): T => {
	const entriesClean = Object.entries(obj).map(([key, value]) => {
		if (value === '') {
			return [key, undefined];
		}
		return [key, value];
	});
	return Object.fromEntries(entriesClean);
};
